<template>
    <div class="roof-search">
        <div class="placeholder-container" v-if="placeholder"></div>
        <div class="roof-search-container" ref="roofContainer">
            <div class="top-header">
                <div class="left-content" v-if="leftContent">
                <!-- <img
                    @click="popupLeft"
                    :src="showPopupLeft?navImgSelect:navImg"
                    alt
                    class="nav-icon"
                /> -->
                <i class="iconfont icon-caidan"  @click="popupLeft"></i>
                </div>
                <div class="filter-button" @click="typeFilter1(1)" v-if="showType">
                    <img class="icon" src="@/assets/img/filtrate-icon-2.png" alt="">
                    <span class="text">根据管型筛选</span>
                    <i v-if="showNewIcon === 1" class="iconfont icon-youjiantou"></i>
                    <img v-if="showNewIcon === 2" class="new-icon" src="@/assets/img/arrow-left-bold.png" alt="">
                </div>
                <div class="middle-content" v-if="middleContent">
                    <i class="iconfont icon-sousuo"></i>
                    <!--          <input type="text" v-model="searchValue" placeholder="请输入产品名称" class="input">-->
                    <van-field
                        v-model="searchValue"
                        @input="searchInput"
                        placeholder="输入产品名称"
                        class="input"
                    />
                </div>
                <div class="right-content" v-if="rightContent">
                    <i class="iconfont icon-shaixuan" @click="tyleFiltrate"></i>
                </div>
            </div>
            <div class="button-filter" v-if="!showType">
                <div class="filter-button" @click="typeFilter(1)" v-if="!showType">
                    <img class="icon" src="@/assets/img/filtrate-icon-2.png" alt="">
                    <span class="text">根据管型筛选</span>
                    <i v-if="showNewIcon === 1" class="iconfont icon-youjiantou"></i>
                    <img v-if="showNewIcon === 2" class="new-icon" src="@/assets/img/arrow-left-bold.png" alt="">
                </div>
                <div class="filter-button" @click="typeFilter(2)" v-if="showApp">
                    <img class="icon" src="@/assets/img/filtrate-icon-1.png" alt="">
                    <span class="text" v-if="showApp">根据应用筛选</span>
                    <i v-if="showNewIcon === 1" class="iconfont icon-youjiantou"></i>
                    <img v-if="showNewIcon === 2" class="new-icon" src="@/assets/img/arrow-left-bold.png" alt="">
                </div>
            </div>

        </div>
        <van-popup v-model="showPopupLeft" position="left" :style="{ height: '100%' }">
            <div class="popup-left-container">
                <div class="options" @click="goRouter('productStore')">产品商城</div>
                <div class="options" @click="goRouter('solutionList')">解决方案</div>
                <div class="options" @click="goRouter('sceneActivity')">小 E 活动</div>
                <div class="options" @click="goRouter('caseShare')">案例分享</div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import { getAllCategory } from '@/api/product'
import { debounce } from '@/libs/util'
export default {
    data () {
        return {
            navImg: require('@/assets/img/nav-icon2.png'),
            navImgSelect: require('@/assets/img/nav-icon.png'),
            searchValue: '',
            showPopupLeft: false, // 左侧弹出层
            popupRightHeight: 500, // 右侧导航筛选的默认高度
            // categoryItems: [],
            activeId: 0,
            activeIndex: 0,
        }
    },
    props: {
        leftContent: {
            type: Boolean,
            default: true
        },
        middleContent: {
            type: Boolean,
            default: true
        },
        rightContent: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: Boolean,
            default: false
        },
        showApp: {
            type: Boolean,
            default: true
        },
        showNewIcon: {
            type: Number,
            default: 1
        },
        showType: {
            type: Boolean,
            default: false
        }
    },
    created () {
        // this.getAllCategoryPort()
    },
    mounted () {
        var bodyHeight = document.querySelector('body').clientHeight
        var topContentHeight = this.$refs.roofContainer.clientHeight
        this.popupRightHeight = bodyHeight - topContentHeight
    },
    methods: {
        searchInput: debounce(function (val) {
            this.$emit('searchInputChange', val)
        }, 800),
        // 路由跳转
        goRouter (name) {
            this.showPopupLeft = false
            this.$router.push(name)
            // if (name !== this.$route.name) {
            //     this.showPopupLeft = false
            //     this.$router.push(name)
            // } else {
            //     this.showPopupLeft = false
            // }
        },
        typeFilter1 () {
            // window.location.href = 
            history.replaceState(null, null, window.location.origin + '/eppendorf_single/index.html?from=singlemessage&isappinstalled=0#/centrifuge?type=1')
            location.reload()
        },
        typeFilter (val) {
            switch (val) {
            case 1:
                this.$store.commit('setCentrifugeRefresh', true)
                this.$router.push({
                    name: 'filterProduct',
                    query: {
                        category_id: 106
                    }
                })
                break
            case 2:
                this.$emit('input', true)
                break
            }
        },
        // 单击了左侧导航
        popupLeft () {
            this.showPopupLeft = !this.showPopupLeft
        },
        // 单击了类别筛选
        tyleFiltrate () {
            this.showPopupLeft = false
        },
        // 格式化数据
        formatData (categoryItems) {
            categoryItems = categoryItems.map((val, key, arr) => {
                val.text = val.title
                if (val.children) {
                    val.children.map((val1, key1, arr1) => {
                        val1.text = val1.title
                    })
                }
                return val
            })
            return categoryItems
        },

        /** 网络请求 **/
        // 获取所有类别
        getAllCategoryPort () {
            getAllCategory()
                .then(res => {
                    var categoryItems = res
                    categoryItems = this.formatData(categoryItems)
                    // console.log('打印数据啊', categoryItems)
                    this.categoryItems = categoryItems
                })
                .catch(err => {
                    this.$toast('获取类别接口失败')
                    console.log('获取所有类别接口失败', err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.filter-button{
                width: rem(155);
                height: rem(36);
                border-radius: rem(5);
                color: #fff;
                font-size: rem(12);
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 rem(10) 0 rem(6);
                &:nth-child(2){
                    background: #6DC6DC;
                    border: 1px solid #0094B9;
                }
                // &:nth-child(2){
                //     background: #3664CD;
                //     border: 1px solid #1440A6;
                // }
                .icon{
                    width: rem(29);
                    height: rem(29);
                }
                .new-icon {
                    width: rem(13);
                    height: rem(13);
                }
                .text{}
                .icon-youjiantou{
                    font-size: rem(13);
                    transform: rotate(90deg);
                }
            }
.roof-search {
    .placeholder-container {
        width: 100%;
        height: rem(46);
        background: none;
    }
    .roof-search-container {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 10;
        background: #fff;
        .top-header{
            display: flex;
            align-items: center;
            height: rem(46);
            padding: rem(5) rem(15) rem(5) 0;
            width: 100%;
        }
        .button-filter{
            height: rem(55);
            padding: 0 rem(20);
            display: flex;
            align-items: center;
            justify-content: space-between;
            .filter-button{
                width: rem(155);
                height: rem(36);
                border-radius: rem(5);
                color: #fff;
                font-size: rem(12);
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding: 0 rem(10) 0 rem(6);
                &:nth-child(1){
                    background: #6DC6DC;
                    border: 1px solid #0094B9;
                }
                &:nth-child(2){
                    background: #3664CD;
                    border: 1px solid #1440A6;
                }
                .icon{
                    width: rem(29);
                    height: rem(29);
                }
                .new-icon {
                    width: rem(13);
                    height: rem(13);
                }
                .text{}
                .icon-youjiantou{
                    font-size: rem(13);
                    transform: rotate(90deg);
                }
            }
        }
        .left-content {
            width: 15%;
            text-align: center;
            .nav-icon {
                width: rem(18);
                height: rem(18);
            }
            .icon-caidan{
                color: #6DC6DC;
                font-size: rem(22);
                font-weight: bold;
            }
        }
        .middle-content {
            width: 85%;
            height: 100%;
            border-radius: 4px;
            display: flex;
            align-items: center;
            color: #9d9d9d;
            padding: 0 rem(11);
            background: #f4f4f4;
            .iconfont {
                color: #9d9d9d;
            }
            .van-cell {
                padding-left: rem(8);
            }
            .input {
                background: none;
            }
        }
        .right-content {
            width: 20%;
            text-align: center;
            i {
                font-size: rem(20);
                color: #4d4d4d;
            }
        }
    }
    .popup-left-container {
        width: rem(186);
        padding-top: rem(16);
        .options {
            height: rem(40);
            line-height: rem(40);
            border-bottom: 1px solid #e0e0e0;
            padding-left: rem(19);
            color: $base-color;
            font-size: 15px;
            font-weight: bold;
        }
    }
    .popup-right-container {
        padding-top: rem(46);
        width: rem(300);
        // 选中的颜色
        .van-sidebar-item--select {
            border-color: $base-color;
            &:before {
                background: white;
            }
        }
        .van-tree-select__item--active {
            color: $base-color;
        }
        .van-tree-select__item {
            font-weight: normal;
        }
    }
}
</style>
